module.exports = __webpack_public_path__ + "static/ContentGrowth-adbb3eb1c55da6b55cbdb35d68206a7c.png";